import { Reveal, Kicker } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Deux maisons, une conviction",
    text: "ASAP Technologies, ESN de référence depuis plus de 15 ans (systèmes, digital, conseil, réseaux, cybersécurité), s'allie à Reqen Consulting, cabinet expert en ingénierie agile, ingénierie système et ingénierie des exigences. Deux cultures complémentaires, une même exigence de qualité.",
  },
  {
    num: "02",
    title: "L'ingénierie agile, sans compromis",
    text: "Trop souvent, la mise en place de pratiques agiles se fait au détriment de la maîtrise des processus, méthodes et techniques d'ingénierie. Nous combinons les deux mondes : l'agilité pour concevoir vite et de manière itérative, l'ingénierie pour concevoir juste, dans les coûts et les délais.",
  },
  {
    num: "03",
    title: "Des offres packagées, actionnables",
    text: "Cinq offres claires, calibrées et immédiatement mobilisables : du diagnostic flash de 2 jours à l'accompagnement sur mesure. Chaque intervention livre des artefacts concrets — radar de maturité, feuille de route, référentiels, plans d'action priorisés.",
  },
];

const COMPANIES = [
  {
    name: "ASAP Technologies",
    color: "bg-blue-500",
    url: "https://asaptech.fr",
    desc: "ESN — Systèmes, Réseaux Télécom & Sécurité, Digital, Conseil, IBM. Plus de 15 ans d'activité, 90+ talents, certifiée Ecovadis.",
    tag: "L'humain d'abord",
  },
  {
    name: "Reqen Consulting",
    color: "bg-teal-400",
    url: "https://www.reqen.fr",
    desc: "Conseil, coaching et formation en ingénierie agile, ingénierie système et ingénierie des exigences. Plus de 30 ans d'expérience dans l'industrie et les SI.",
    tag: "Ingénierie Agile",
  },
];

export default function Manifesto() {
  return (
    <section id="partenariat" className="relative py-16 md:py-24 lg:py-32" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Kicker>Le partenariat</Kicker>
          <h2 className="mt-5 font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-50 max-w-2xl">
            Quand l'ingénierie rencontre l'agilité,{" "}
            <span className="grad-text">la qualité cesse d'être un arbitrage.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {COMPANIES.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.12}>
              <a
                href={c.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`company-card-${i}`}
                className="block border border-white/10 bg-[#131b2c] p-8 card-lift h-full"
              >
                <div className="flex items-center justify-between">
                  <span className={`h-2.5 w-2.5 rounded-full ${c.color}`} />
                  <span className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-slate-500">{c.tag}</span>
                </div>
                <h3 className="mt-5 font-heading text-xl sm:text-2xl font-semibold text-slate-100">{c.name}</h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{c.desc}</p>
                <span className="mt-5 inline-block text-xs text-teal-300">{c.url.replace("https://", "")} →</span>
              </a>
            </Reveal>
          ))}
        </div>

        <div className="mt-20 space-y-0 border-t border-white/10">
          {CHAPTERS.map((ch, i) => (
            <Reveal key={ch.num} delay={i * 0.08}>
              <div
                className="grid md:grid-cols-12 gap-4 md:gap-8 py-10 border-b border-white/10 group"
                data-testid={`manifesto-chapter-${ch.num}`}
              >
                <div className="md:col-span-2 font-heading text-4xl sm:text-5xl font-extrabold text-white/10 group-hover:grad-text transition-all">
                  {ch.num}
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-heading text-xl sm:text-2xl font-semibold text-slate-100">{ch.title}</h3>
                </div>
                <div className="md:col-span-6">
                  <p className="text-slate-400 text-sm sm:text-base leading-relaxed">{ch.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
